import { Route } from "@angular/router";
import { UsersPage } from "app/modules/user-management/pages/users/users.page";
import { RolesPermissionPage } from "app/modules/user-management/pages/roles-permission/roles-permissions.page";

export const umDashboardRoutes: Route[] = [
    {
        path: 'user-management',
        children: [],
    },
];

export const umDataManagementRoutes: Route[] = [
    {
        path: 'user-management',
        children: [],
    },
];

export const umConfigurationRoutes: Route[] = [
    {
        path: 'user-management',
        children: [
            {
                path: 'users',
                component: UsersPage
            },
            {
                path: 'roles-permissions',
                component: RolesPermissionPage
            }],
    },
];
